const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1/site';
const API_ROOT = API_URL.split('/api/')[0];

export { API_URL, API_ROOT };